import React, { useState, useRef, useEffect } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import busStations from "../../../Data/BusStations.json";
import { RiCalendarEventLine, RiMapPin2Line, RiArrowLeftRightLine } from "react-icons/ri";
import styles from "./ModifyBusSearch3.module.css";

const BusCustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <div className={styles.inputWrapper} onClick={onClick}>
    <RiCalendarEventLine className={styles.fieldIcon} />
    <input type="text" className={styles.customInput} value={value} ref={ref} readOnly />
  </div>
));

const ModifyBusSearch3 = ({ searchQuery, onSearch }) => {
  const [fromStation, setFromStation] = useState(searchQuery?.fromStation || "");
  const [toStation, setToStation] = useState(searchQuery?.toStation || "");
  const [fromStationId, setFromStationId] = useState(searchQuery?.fromStationCode || "");
  const [toStationId, setToStationId] = useState(searchQuery?.toStationCode || "");
  const [travelDate, setTravelDate] = useState(() => {
    if (searchQuery?.travelDate) {
      return moment(searchQuery.travelDate, "YYYY-MM-DD").toDate();
    }
    return new Date();
  });

  const [errors, setErrors] = useState({});
  const [fromStationResults, setFromStationResults] = useState([]);
  const [toStationResults, setToStationResults] = useState([]);
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);

  const handleFromSearch = (e) => {
    const val = e.target.value;
    setFromStation(val);
    if (val.length > 0) {
      setFromStationResults(busStations.stationList.filter(s => s.stationName.toLowerCase().includes(val.toLowerCase())).slice(0, 6));
    } else setFromStationResults([]);
  };

  const handleToSearch = (e) => {
    const val = e.target.value;
    setToStation(val);
    if (val.length > 0) {
      setToStationResults(busStations.stationList.filter(s => s.stationName.toLowerCase().includes(val.toLowerCase())).slice(0, 6));
    } else setToStationResults([]);
  };

  const swapStations = () => {
    const tempName = fromStation;
    const tempId = fromStationId;
    setFromStation(toStation);
    setFromStationId(toStationId);
    setToStation(tempName);
    setToStationId(tempId);
  };

  const validate = () => {
    let temp = {
      fromStation: fromStation !== "",
      toStation: toStation !== "",
      travelDate: travelDate !== null,
      sameStation: fromStation !== toStation
    };
    setErrors(temp);
    return Object.values(temp).every(x => x === true);
  };

  const handleModify = (e) => {
    e.preventDefault();
    if (validate()) {
      onSearch({
        fromStationCode: fromStationId,
        fromStation,
        toStationCode: toStationId,
        toStation,
        travelDate: moment(travelDate).format("YYYY-MM-DD"),
      });
    }
  };

  return (
    <div className={styles.modifyContainer}>
      <div className={styles.searchRow}>
        
        {/* FROM */}
        <div className={styles.inputGroup}>
          <label className={styles.editorialLabel}>Origin</label>
          <div className={styles.inputWrapper}>
            <RiMapPin2Line className={styles.fieldIcon} />
            <input
              className={styles.customInput}
              type="text"
              value={fromStation}
              onChange={handleFromSearch}
              ref={fromInputRef}
              placeholder="Leaving from"
            />
            {fromStationResults.length > 0 && (
              <ul className={styles.suggestionList}>
                {fromStationResults.map((s) => (
                  <li key={s.stationId} onClick={() => { setFromStation(s.stationName); setFromStationId(s.stationId); setFromStationResults([]); }}>
                    {s.stationName}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <button type="button" className={styles.swapBtn} onClick={swapStations}>
          <RiArrowLeftRightLine />
        </button>

        {/* TO */}
        <div className={styles.inputGroup}>
          <label className={styles.editorialLabel}>Destination</label>
          <div className={styles.inputWrapper}>
            <RiMapPin2Line className={styles.fieldIcon} />
            <input
              className={styles.customInput}
              type="text"
              value={toStation}
              onChange={handleToSearch}
              ref={toInputRef}
              placeholder="Going to"
            />
            {toStationResults.length > 0 && (
              <ul className={styles.suggestionList}>
                {toStationResults.map((s) => (
                  <li key={s.stationId} onClick={() => { setToStation(s.stationName); setToStationId(s.stationId); setToStationResults([]); }}>
                    {s.stationName}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* DATE */}
        <div className={styles.inputGroup} style={{ flex: '0 0 160px' }}>
          <label className={styles.editorialLabel}>Date</label>
          <DatePicker
            selected={travelDate}
            onChange={(date) => setTravelDate(date)}
            customInput={<BusCustomDateInput />}
            dateFormat="dd MMM yyyy"
          />
        </div>

        <button type="button" className={styles.modifyBtn} onClick={handleModify}>
          UPDATE
        </button>
      </div>
      
      {errors.sameStation === false && <p className={styles.errorMsg}>Origin and Destination cannot be same</p>}
    </div>
  );
};

export default ModifyBusSearch3;